import React from 'react'
import PropTypes from 'prop-types'

class InstructorTrainerSelect extends React.Component {
  state = {
    instructorTrainerId: this.props.instructorTrainerId
  }

  onInstructorTrainerChange = (e) => {
    this.setState({ instructorTrainerId: e.target.value })
    setTimeout(function() { this.props.newInstructorTrainerCallback(this.state.instructorTrainerId) }.bind(this), 50)
  }

  render() {
    return(
      <div className={this.props.selectClassName}>
        <select className='form-control'
                title='Instructor Trainer'
                value={this.state.instructorTrainerId}
                onChange={(e) => this.onInstructorTrainerChange(e)}>
          <option value=''>
            All Instructor Trainers
          </option>
          {this.props.instructorTrainers.map((instructorTrainer) =>
            <option
              key={instructorTrainer.id}
              value={instructorTrainer.id}
            >
              {this.props.isSaiAdmin ? instructorTrainer.full_name_reverse_with_account : instructorTrainer.full_name_reverse}
            </option>
          )}
        </select>
      </div>
    )
  }
}

InstructorTrainerSelect.propTypes = {
  instructorTrainerid: PropTypes.number,
  instructorTrainers: PropTypes.array,
  selectClassName: PropTypes.string,
  isSaiAdmin: PropTypes.bool
}

export default InstructorTrainerSelect
